var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{attrs:{"link":"","disabled":_vm.disabled,"title":_vm.alt},nativeOn:{"click":function($event){return _vm.saveData.apply(null, arguments)}}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }